import { useDispatch } from "react-redux";
import ConfirmationModal from "../../../../../globals/core/Modal/Confirmation";
import { setModalChild, setModalState } from "../../../../../store/actions/modalActions";
import { Button } from "reactstrap";
import { useHistory } from "react-router-dom";
import { EventsService } from "../../../../../globals/services/events.service";
import deleteButtonIcon from "../../../../../assets/images/delete-button.svg";
import styles from "./index.module.scss";

interface EventChangesProps {
    state: any;
    itemWasChanged?: boolean;
}
const EventChanges = ({ state, itemWasChanged }: EventChangesProps) => {    
    const dispatch = useDispatch();
    const history = useHistory();

    const handleDeleteEvent = () => {
        const confirmDeletion = (
            <ConfirmationModal
                title="Delete Event"
                question="Are you sure you want to delete this event?"
                onConfirm={() => finalDeleteEvent()}
            />
        );

        dispatch(setModalChild(confirmDeletion));
        dispatch(setModalState(true));
    };

    const finalDeleteEvent = async () => {
        await EventsService().deleteEvent(state);
        dispatch(setModalState(false));
        history.push("/Events");
    };

    const handleUpdateEvent = async () => {
        const updatedEvent = { ...state };
        delete updatedEvent.selectedFiles;
        localStorage.setItem("event", JSON.stringify(updatedEvent));

        if (updatedEvent.communityIds && Array.isArray(updatedEvent.communityIds)) {
            updatedEvent.communityIds = updatedEvent.communityIds?.map((c: any) => c.value);
        }

        updatedEvent.related = updatedEvent.related.map((r: any) => r.value);
        await EventsService().updateEvent(updatedEvent);
        history.push({
            pathname: "/Events",
        });
    };

    return (
        <div className={styles.eventChanges}>
            <div className={styles.deleteDialog}>
                <Button className={styles.deleteButton} onClick={() => handleDeleteEvent()}>
                    <img src={deleteButtonIcon} alt="Delete Event" />
                </Button>
            </div>
            {itemWasChanged && (
                    <div className={styles.saveDialog}>
                        <Button onClick={() => handleUpdateEvent()} className={styles.saveButton}>
                            Save Changes
                        </Button>
                    </div>
            )}
        </div>
    );
};

export default EventChanges;